module.exports = __webpack_public_path__ + "static/footer-particle-0b9e41ab38adfd4f3f6cf67afdf35912.png";